import { render, staticRenderFns } from "./TableHistoricalOperation.vue?vue&type=template&id=6360373e&"
import script from "./TableHistoricalOperation.vue?vue&type=script&lang=js&"
export * from "./TableHistoricalOperation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports